
import { defineComponent, PropType } from 'vue';
import { ICteImposto } from '@/models/Entidades/Compras/ConhecimentoTransporte/ICteImposto';

export default defineComponent({
  name: 'ConhecimentoTransporteImpostos',
  props: {
    impostos: {
      type: Array as PropType<ICteImposto[]>,
    },
  },
  setup() {
    const colunas = [
      {
        title: 'CST ICMS',
        dataIndex: 'cstIcms',
        key: 'cstIcms',
      },
      {
        title: 'Valor ICMS',
        dataIndex: 'valorIcms',
        key: 'valorIcms',
      },
    ];

    return {
      colunas,
    };
  },
});
